module.exports = "https://cdn.redage.net/src/views/donate/main/elements/shop/img/top_up.png";